import { ModalCloseButton } from './modal-close-button';

export default ModalCloseButton;
